import { gql, type TypedDocumentNode } from "@apollo/client";
import type {
  CommitteeParticipantsQueryResponse,
  CommitteeParticipantsQueryVariables,
  CommitteesQueryResponse,
  CommitteesQueryVariables
} from "./types";

export const COMMITTEES_QUERY: TypedDocumentNode<CommitteesQueryResponse, CommitteesQueryVariables> = gql`
  query Committees(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $input: BackofficeMembershipLegacyCommitteesInput
    $orderBy: BackofficeMembershipLegacyCommitteeOrderByInput
  ) {
    committees: legacyCommittees(
      first: $first
      last: $last
      before: $before
      after: $after
      input: $input
      orderBy: $orderBy
    ) {
      nodes {
        id
        name
        status
        type
        termCount
        totalParticipationCount
        terms {
          id
          startDate
          endDate
          status
          participantCount
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const COMMITTEE_PARTICIPANTS_QUERY: TypedDocumentNode<
  CommitteeParticipantsQueryResponse,
  CommitteeParticipantsQueryVariables
> = gql`
  query CommitteeParticipants($input: BackofficeMembershipLegacyCommitteeParticipantsInput!) {
    committeeParticipants: legacyCommitteeParticipants(input: $input) {
      id
      pgaId
      position
      startDate
      endDate
      person {
        displayName
        pgaId
        profilePhoto
      }
    }
  }
`;
